module.exports = __webpack_public_path__ + "img/globe.e6b752f.svg";